import { render, staticRenderFns } from "./LeadsCardEdit.vue?vue&type=template&id=179a15ac&scoped=true&"
import script from "./LeadsCardEdit.vue?vue&type=script&lang=js&"
export * from "./LeadsCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardEdit.vue?vue&type=style&index=0&id=179a15ac&lang=scss&scoped=true&"
import style1 from "./LeadsCardEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a15ac",
  null
  
)

export default component.exports